import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Spinner } from "reactstrap";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PieChart from "components/shared/Charts/PieChart";
import { RepositoryFactory } from "repository/RepositoryFactory";

let Stats = RepositoryFactory.get("stats");

const PaymentMethod = ({ type, dates, merchant }) => {
  const { startDate, endDate } = dates;
  const { user } = useSelector((state) => state.auth);

  const payload = {
    type,
    dateRange: { startDate, endDate },
    id:
      user?.type === "restaurant"
        ? user?.restaurantID
        : user?.type === "admin" && merchant?.id
        ? merchant?.id
        : ""
  };

  const {
    data: latestPaymentMethod,
    isFetching,
    isError,
    error
  } = useQuery({
    queryKey: ["paymentMethods", payload],
    queryFn: async () => {
      const { data } = await Stats.getPaymentMethod(payload);
      return data?.data;
    },
    staleTime: 60 * 60 * 1000,
    cacheTime: 70 * 60 * 1000,
    keepPreviousData: true
  });

  if (isError) {
    toast.error(error?.message || "Failed to load payment methods.");
  }

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const labels =
    latestPaymentMethod?.map((item) => capitalize(item.method)) || [];
  const paymentSeries =
    latestPaymentMethod?.map((item) => parseFloat(item.orders)) || [];

  const paymentOptions = {
    chart: { type: "pie" },
    labels,
    legend: { fontFamily: "Poppins, sans-serif" },
    dataLabels: { enabled: true },
    tooltip: { enabled: true }
  };

  return (
    <Card className="header-cards card overflow-hidden">
      <CardHeader className="d-flex justify-content-between flex-column flex-sm-row">
        <h3 className="mb-0">Payment Method</h3>
      </CardHeader>
      {isFetching ? (
        <Spinner size="sm" color="primary" className="mx-auto my-5" />
      ) : (
        <CardBody className="d-flex justify-content-center align-items-center">
          <PieChart
            chartOptions={paymentOptions}
            chartSeries={paymentSeries}
            type="pie"
          />
        </CardBody>
      )}
    </Card>
  );
};

export default PaymentMethod;
